"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _InputRaw = _interopRequireDefault(require("../InputRaw"));

var _InputContainer = _interopRequireDefault(require("../InputContainer"));

var __jsx = _react["default"].createElement;

function isValueEmpty(val) {
  return val === undefined || val === null || val.toString() === "";
}

function Input$(props) {
  var onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["onChange"]);

  var _useState = (0, _react.useState)(props.value),
      value = _useState[0],
      setValue = _useState[1];

  var isEmpty = isValueEmpty(value); // let [isEmpty, setEmpty] = useState(isValueEmpty(props.value));

  var onChangeEvent = function onChangeEvent(val, e) {
    setValue(val);

    if (onChange) {
      onChange(val, e);
    }
  };

  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: isEmpty,
    onClear: function onClear() {
      onChangeEvent("", null);
    },
    label: props.label || props.placeholder,
    cursor: "text"
  }), __jsx(_InputRaw["default"], {
    sx: {
      width: "100%",
      height: "100%"
    },
    onChange: onChangeEvent,
    value: value
  }));
}

var _default = Input$;
exports["default"] = _default;